import { eFinancialActionTypeDefine } from "../../action-types/financial/IFinancialActions";
import { generateActions } from "../generateActions";

export const financialActions = {
    ...generateActions(eFinancialActionTypeDefine, "FINANCIAL"),
};
